export default function createMapLegendElement() {
  const element = document.createElement('div');

  element.className = 'nhs-c-map__legend';
  element.setAttribute('data-map-legend', '');
  element.setAttribute('data-qa-attribute', 'map-legend');
  element.setAttribute('data-plugin-owned', 'map-legend');

  element.innerHTML = `
    <div class="nhs-c-map__legend--container">
      <input id="map-legend-toggle" class="nhs-c-map__legend--toggle" type="checkbox" hidden checked />
      <label for="map-legend-toggle" class="nhs-c-map__legend--button" data-qa="legend-toggle">
        <span data-map-legend-title data-qa="legend-title">Legend</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
          <path fill="currentColor" d="M13.647 10.354a.5.5 0 1 0 .707-.708L9.06 4.354a1.5 1.5 0 0 0-2.122 0L1.646 9.646a.5.5 0 1 0 .708.707l5.292-5.292a.5.5 0 0 1 .708 0z"/>
        </svg>
      </label>
      <div class="nhs-c-map__legend--options" data-map-legend="pins" data-qa="legend-pins">
        <div>
          <div class="nhs-c-map__legend--option nhs-c-map__legend--option--communities-homes" data-qa="communitiesHomesLegendPin"></div>
          <p class="nhs-c-map__legend--option-label" data-qa="communitiesHomesLegendLabel">Communities & Homes</p>
        </div>
        <div>
          <div class="nhs-c-map__legend--option nhs-c-map__legend--option--fifty-five" data-qa="fiftyFiveLegendPin"></div>
          <p class="nhs-c-map__legend--option-label" data-qa="fiftyFiveLegendLabel">55+ Communities</p>
        </div>
        <div>
          <div class="nhs-c-map__legend--option nhs-c-map__legend--option--master-planned" data-qa="masterPlannedLegendPin"></div>
          <p class="nhs-c-map__legend--option-label" data-qa="masterPlannedLegendLabel">Master Planned</p>
        </div>
        <div>
          <div class="nhs-c-map__legend--option nhs-c-map__legend-option--community-explorer" data-qa="communityExplorerLegendPin"></div>
          <p class="nhs-c-map__legend--option-label" data-qa="communityExplorerLegendLabel">Community Explorer</p>
        </div>
      </div>
    </div>
  `;

  return element;
}